export async function fetchEfficiencyDataByPrString({ webApiBaseUrl, country, language, prString, }) {
    const encodedPrString = encodeURIComponent(prString);
    const url = `${webApiBaseUrl}/tedas/v1/${country}/${language}/efficiencyDataByPrString?prString=${encodedPrString}`;
    const response = await fetch(url);
    if (!response.ok) {
        const error = await response.text();
        console.error(`Failed to fetch efficiency data for PR string: ${prString}`, { error });
        return null;
    }
    const data = await response.json();
    return data;
}
//# sourceMappingURL=tedas.js.map